import { Navigate } from "react-router-dom";

/** Legacy Order Reports → Sales (selling lines) report */
const Reports = () => <Navigate to="/reports/selling" replace />;

export default Reports;
